import {useContext} from 'react';
import {Context as AuthContext} from '../contexts/AuthContext';

export const useAuth = () => useContext(AuthContext);
